import { routesMap } from '@shared/lib';

export const getSafeRedirect = (value: string | null | undefined) => {
  if (!value || !value.startsWith('/') || value.startsWith('//')) {
    return routesMap.home;
  }

  try {
    const url = new URL(value, window.location.origin);

    if (url.origin !== window.location.origin) {
      return routesMap.home;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return routesMap.home;
  }
};

export const getAuthRedirect = (pathname: string, search: string) => {
  const currentPath = `${pathname}${search}`;

  return `${routesMap.auth}?redirect=${encodeURIComponent(currentPath)}`;
};
